import { render, staticRenderFns } from "./districtsSubClassifierView.vue?vue&type=template&id=70f5f182&scoped=true"
import script from "./districtsSubClassifierView.vue?vue&type=script&lang=js"
export * from "./districtsSubClassifierView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f5f182",
  null
  
)

export default component.exports